import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import CompanyItem from './companyItem';
import CompanyGroupSelector from './companyGroupSelector';
import locales from './locales';

const ICON_CARET_DOWN = 'ri-arrow-down-s-line';

class CompanySelector extends Component {
  static propTypes = {
    authInfo: PropTypes.object.isRequired,
    companies: PropTypes.array.isRequired,
    groupCompanies: PropTypes.array.isRequired,
    myAccountUrl: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.handleToggleCompanySelector = this.handleToggleCompanySelector.bind(this);
    this.state = { companySelectorOpen: false };
  }

  handleToggleCompanySelector() {
    const { companySelectorOpen } = this.state;
    this.setState({ companySelectorOpen: !companySelectorOpen });
  }

  // Warning: react-onclickoutside use this
  handleClickOutside() {
    this.setState({ companySelectorOpen: false });
  }

  getGroupCompanies() {
    const { lang, groupCompanies, authInfo, myAccountUrl } = this.props;
    return (
      <CompanyGroupSelector
        authInfo={authInfo}
        groupCompanies={groupCompanies}
        lang={lang}
        myAccountUrl={myAccountUrl}
      />
    );
  }

  getMenuContent() {
    const { lang, onChangeCompany, authInfo, companies, groupCompanies } = this.props;
    const groupId = authInfo.getGroupId();
    const t = locales(lang);

    const items = companies.map((company, i) => (
      <CompanyItem
        id={company.id}
        groupId={groupId}
        href="#"
        key={i}
        onClick={this.handleToggleCompanySelector}
        name={company.name}
        onChangeCompany={onChangeCompany}
      />
    ));

    const groupCompaniesMarkup =
      (groupCompanies && groupCompanies.length > 0 && this.getGroupCompanies()) || '';

    return (
      <Fragment>
        <div className="default__group">
          {groupCompaniesMarkup && (
            <label className="label__companies">{t('globalHeader.companies.labelCompanies')}</label>
          )}
          <div className="group__content">{items}</div>
        </div>
        {groupCompaniesMarkup}
      </Fragment>
    );
  }

  render() {
    const { authInfo } = this.props;
    const companyId = authInfo.getCompanyId();
    const groupId = authInfo.getGroupId();

    const { companySelectorOpen } = this.state;

    return (
      <div role="listbox" className={'account__dropdown'} tabIndex="0">
        <div
          className={`account__dropdown--is-open ${companySelectorOpen ? 'is-active' : ''}`}
          onClick={this.handleToggleCompanySelector}
        >
          <p title={`${authInfo.getGroupId()}-${authInfo.getCompanyId()}`}>
            {authInfo.getCompanyName()} ({authInfo.getGroupId()} - {authInfo.getCompanyId()})
            <i className={ICON_CARET_DOWN} />
          </p>
        </div>
        <div className={'account__menu'} title={`${companyId}-${groupId}`}>
          {this.getMenuContent()}
        </div>
      </div>
    );
  }
}

CompanySelector.propTypes = {
  authInfo: PropTypes.object.isRequired,
  onChangeCompany: PropTypes.func,
  companies: PropTypes.array.isRequired,
  groupCompanies: PropTypes.array.isRequired,
  myAccountUrl: PropTypes.string.isRequired,
};

export default onClickOutside(CompanySelector);
